import React from "react";
import { useNavigate } from "react-router-dom";
import { Result, Button } from "antd";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Result
      status="404"
      title="404"
      subTitle="Lo sentimos, la página que buscas no existe."
      extra={
        <Button type="primary" onClick={() => navigate("/admin")}>
          Volver al Inicio
        </Button>
      }
    />
  );
};

export default NotFound;
